/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiPlatform;
(function (ApiPlatform) {
    ApiPlatform["PLATFORM_UNSPECIFIED"] = "PlatformUnspecified";
    ApiPlatform["PLATFORM_SHOPIFY"] = "PlatformShopify";
    ApiPlatform["PLATFORM_ECWID"] = "PlatformEcwid";
    ApiPlatform["PLATFORM_WOOCOMMERCE"] = "PlatformWoocommerce";
    ApiPlatform["PLATFORM_SPA"] = "PlatformSpa";
    ApiPlatform["PLATFORM_STANDARD"] = "PlatformStandard";
    ApiPlatform["PLATFORM_WORDPRESS"] = "PlatformWordpress";
})(ApiPlatform || (ApiPlatform = {}));
export function ApiPlatformFromJSON(json) {
    return ApiPlatformFromJSONTyped(json, false);
}
export function ApiPlatformFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiPlatformToJSON(value) {
    return value;
}
